module.exports = __webpack_public_path__ + "static/media/cards24.09587843.png";